// extracted by mini-css-extract-plugin
export default {"footerContainer":"AddToExistingWatchlists_footerContainer__+OX4W"};